export const MSR_DATASETS = {
  faculty: {
    label: "Teaching Faculty",
    singular: "faculty record",
    fields: [
      "name",
      "aebas_id",
      "registration_no",
      "qualification",
      "department",
      "designation",
      "employment_nature",
      "teaching_experience",
    ],
    columns: ["name", "department", "designation", "qualification", "aebas_id"],
  },
  residents: {
    label: "Tutors & Senior Residents",
    singular: "tutor or senior resident",
    fields: ["name", "department", "designation"],
    columns: ["name", "department", "designation"],
  },
  non_teaching: {
    label: "Non-Teaching Staff",
    singular: "non-teaching staff record",
    fields: ["employee_id", "name", "designation", "department"],
    columns: ["employee_id", "name", "designation", "department"],
  },
  ug_courses: {
    label: "UG Courses",
    singular: "UG course",
    fields: ["name", "seat_count", "recognition_details", "document_reference"],
    columns: ["name", "seat_count", "recognition_details", "document_reference"],
  },
  pg_courses: {
    label: "PG Courses",
    singular: "PG course",
    fields: ["name", "seat_count", "recognition_details", "document_reference"],
    columns: ["name", "seat_count", "recognition_details", "document_reference"],
  },
};

export const FIELD_CONFIG = {
  employee_id: { label: "Employee ID" },
  name: { label: "Name / Programme" },
  designation: { label: "Designation" },
  department: { label: "Department" },
  qualification: { label: "Qualification", multiline: true },
  aebas_id: { label: "AEBAS Attendance ID" },
  registration_no: { label: "Registration Number", multiline: true },
  employment_nature: { label: "Nature of Employment" },
  teaching_experience: { label: "Teaching Experience (years)" },
  seat_count: { label: "Total Seats", type: "number" },
  recognition_details: { label: "Permission & Recognition", multiline: true },
  document_reference: { label: "Document Reference", multiline: true },
};

export const emptyRecordFor = (dataset) => ({
  ...MSR_DATASETS[dataset].fields.reduce((result, field) => {
    result[field] = "";
    return result;
  }, {}),
  status: "published",
});
